<template>
  <div
    class="industryParent"
    v-lazy:background-image="{
      src: bg,
    }"
  >
    <title-widge :title="title" :subTitle="subTitle"></title-widge>
    <div class="divContent">
      <div v-for="(item, index) in items" :key="index" class="divItem">
        <img
          v-lazy="{
            src: item.url,
            loading: require('./../../../../../assets/wheelplanting.jpg'),
          }"
          alt=""
        />
        <div class="divBg"></div>
        <div class="divContainer">
          <div class="divTitle">{{ item.title }}</div>
          <div class="divDesc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import titleWidge from "./titleWidge";
export default {
  components: {
    titleWidge,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    bg: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/industryAdvantageWidge";
</style>
